import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const ShieldStar = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 5V11.0898C20 16.1398 16.59 20.85 12 22C7.41 20.85 4 16.1398 4 11.0898V5L12 2L20 5ZM10.75 10.75L8 12L10.75 13.25L12 16L13.25 13.25L16 12L13.25 10.75L12 8L10.75 10.75Z"
    />
  </SvgIcon>
));

ShieldStar.displayName = 'ShieldStar';

export default ShieldStar;
